<template>
	<div style="display: inline-block;margin-top: 15px;" :style="{ marginLeft: `${marginLeft}` }">

		<template v-if="inputtype == 'select'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
			  { fontSize: `${fontSize}` },
			  { color: `${color}` },
			  { width: `${lablewith}` },
			]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable style="margin-left: 10px;" :placeholder="placeholder"
					class="elselect" :style="fromelect" @change="events(event)" :disabled="disabled">
					<el-option v-for="(item, index) in options" :key="index" :label="item.value"
						:value="item.key == '' ? item.key : item.key || item.value">
					</el-option>
				</el-select>
			</div>
		</template>
		<!-- 下拉多选框 -->

		<template v-if="inputtype == 'selectMultiple'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-select v-model="modelvalue" multiple clearable collapse-tags style="margin-left: 10px;"
				:placeholder="placeholder" class="elselect" :style="fromelect" @change="events(event)"
				:disabled="disabled">
				<el-option v-for="(item, index) in options" :key="index" :label="item.value"
					:value="item.key == '' ? item.key : item.key || item.value">
				</el-option>
			</el-select>
		</template>
		<template v-if="inputtype == 'province'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-select style="margin-left: 10px;" v-model="modelvalue" :placeholder="placeholder" class="elselect"
				:style="fromelect" @change="province" :disabled="disabled">
				<el-option v-for="(item, index) of options" :key="index" :label="item.value" :value="item.key">
				</el-option>
			</el-select>
		</template>
		<template v-if="inputtype == 'city'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-select style="margin-left: 10px;" v-model="modelvalue" :placeholder="placeholder" class="elselect"
				:style="fromelect" @change="city" :disabled="disabled">
				<el-option v-for="(item, index) of options" :key="index" :label="item.value" :value="item.key">
				</el-option>
			</el-select>
		</template>
		<template v-if="inputtype == 'area'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-select style="margin-left: 10px;" v-model="modelvalue" :placeholder="placeholder" class="elselect"
				:style="fromelect" :disabled="disabled">
				<!--  -->
				<el-option v-for="(item, index) in options" :key="index" :label="item.value" :value="item.key">
				</el-option>
			</el-select>
		</template>
		<template v-if="inputtype == 'treeselect'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<treeselect noResultsText="暂无结果" clearValueText="删除" :options="options" :placeholder="placeholder"
					:normalizer="normalizer" v-model="modelvalue" class="elselect" :style="fromelect" />
			</div>
		</template>
		<template v-if="inputtype == 'cascader'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-cascader collapse-tags :options="options" :props="{ checkStrictly: true, multiple: multiple }"
				@change="cascaderchange" style="margin-left: 10px;" :placeholder="placeholder" v-model="modelvalue"
				class="elselect" :style="fromelect" :show-all-levels="false">
			</el-cascader>
		</template>
		<template v-if="inputtype == 'cascaderNode'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-cascader :options="options" :props="{
          emitPath: false,
          checkStrictly: true,
          multiple: multiple,
          value: 'NodeID',
          label: 'NodeName',
          children: 'Nodes',
        }" @change="cascaderchange" style="margin-left: 10px;" :placeholder="placeholder" v-model="modelvalue"
				class="elselect" :style="fromelect" :show-all-levels="false">
			</el-cascader>
		</template>
		<template v-if="inputtype == 'cascaderNodeParent'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-cascader clearable :options="options" :props="{
          emitPath: false,
          checkStrictly: true,
          multiple: multiple,
          value: 'NodeID',
          label: 'NodeName',
          children: 'Nodes',
        }" @change="cascaderchange" style="margin-left: 10px;height:32px;" :placeholder="placeholder"
				v-model="modelvalue" collapse-tags class="elselect" :style="fromelect" :show-all-levels="false"
				:disabled="disabled">
			</el-cascader>
		</template>
		<template v-if="inputtype == 'cascaders'">
			<label :style="[
          { fontSize: `${fontSize}` },
          { color: `${color}` },
          { width: `${lablewith}` },
        ]">
				<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				<slot></slot>
				{{ title }}:
			</label>
			<el-cascader collapse-tags :options="options" :props="{ checkStrictly: true, multiple: multiple }"
				@change="cascaderchange" style="margin-left: 10px;" :placeholder="placeholder" v-model="modelvalue"
				class="cascaderstyle" :style="fromelect" :show-all-levels="false">
			</el-cascader>
		</template>
		<template v-if="inputtype == 'selects'">
			<el-select style="margin-left: 10px;" v-model="modelvalue" :placeholder="placeholder" class="elselect"
				:style="fromelect">
				<!--  v-for="item in options" :key="item.value" :label="item.label" :value="item.value" -->
				<el-option> </el-option>
			</el-select>
		</template>

		<template v-if="inputtype == 'input'">
			<form style="display: inline-block" v-if="inputflag">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<input v-model="modelvalue" :type="types" @blur="$emit(`${event}`, $event.target.value)"
					:placeholder="placeholder" style="margin-left: 10px;"
					:style="[{ width: `${width}` }, { height: `${height}` }]" :disabled="disabled"
					@input="cascaderchange" />
			</form>
		</template>
		<template v-if="inputtype == 'inputuni'">
			<el-form style="display: inline-block" v-if="inputflag">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<input v-model="modelvalue" :type="types" @keyup.enter.native="wCodeChage" :placeholder="placeholder"
					style="margin-left: 10px;border: 1px solid #E6E6E6;"
					:style="[{ width: `${width}` }, { height: `${height}` }]" :disabled="disabled"
					@input="cascaderchange" />
			</el-form>
		</template>
		<!-- <template v-if="inputtype == 'autocomplete'">
      <form style="display: inline-block" v-if="pt">
        <label :style="[{fontSize: `${ fontSize }` },{ color: `${ color }` },{ width: `${ lablewith }` }]">
          <span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
          <slot></slot>
          {{ title }}:
        </label>

        <el-autocomplete v-model="modelvalue" :fetch-suggestions="querySearchAsync" @select="handleSelect" :type="types" :placeholder="placeholder" class="elselect" :style="fromelect" style="margin-left: 10px;" :disabled="disabled"></el-autocomplete>
      </form>
    </template>
    <template v-if="inputtype == 'autocompletetow'">
      <form style="display: inline-block" v-if="jxs">
        <label :style="[{fontSize: `${ fontSize }` },{ color: `${ color }` },{ width: `${ lablewith }` }]">
          <span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
          <slot></slot>
          {{ title }}:
        </label>
        <el-autocomplete v-model="modelvalue" :fetch-suggestions="querySearchAsynctow" @select="handleSelecttow" :type="types" :placeholder="placeholder" class="elselect" :style="fromelect" style="margin-left: 10px;" :disabled="disabled"></el-autocomplete>
      </form>
    </template> -->
		<template v-if="inputtype == 'selectautocompleteHosType'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword
					:remote-method="remoteHosType" :loading="loading" loading-text="加载中..." style="margin-left: 10px;"
					:placeholder="placeholder" ref="selectautocompletes" class="elselect" :style="fromelect"
					@change="events(event)" :disabled="disabled">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocompletes'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword
					:remote-method="remoteMethodtows" :loading="loading" loading-text="加载中..."
					style="margin-left: 10px;" :placeholder="placeholder" ref="selectautocompletes" class="elselect"
					:style="fromelect" @change="events(event)" :disabled="disabled">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocompleteHB'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword
					:remote-method="remoteMethodtowHB" :disabled="disabledHB" :loading="loading" loading-text="加载中..."
					style="margin-left: 10px;" :placeholder="placeholder" ref="selectautocompletes" class="elselect"
					:style="fromelect" @change="events(event)">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocompleteHP'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
		    { fontSize: `${fontSize}` },
		    { color: `${color}` },
		    { width: `${lablewith}` },
		  ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword :multiple="multiple"
					collapse-tags :remote-method="remoteMethodtowHP" :disabled="disabledHB" :loading="loading"
					loading-text="加载中..." style="margin-left: 10px;" :placeholder="placeholder"
					ref="selectautocompletes" class="elselect" :style="fromelect" @change="events(event)">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'autocompletePer'">
			<div style="display: inline-block" v-if="selcoms">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword
					:remote-method="remoteMethodtowPer" :loading="loading" loading-text="加载中..."
					style="margin-left: 10px;" :placeholder="placeholder" ref="selectautocompletes" class="elselect"
					:style="fromelect" @change="events(event)" :disabled="disabled">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocomplete'">
			<div style="display: inline-block" v-if="pt">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword :disabled="disabled"
					@change="change1" :remote-method="remoteMethod" :loading="loading" style="margin-left: 10px;"
					:placeholder="placeholder" ref="selectautocomplete" class="elselect" :style="fromelect">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocompletemultiple'">
			<div style="display: inline-block" v-if="pt">
				<label :style="[
		    { fontSize: `${fontSize}` },
		    { color: `${color}` },
		    { width: `${lablewith}` },
		  ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" :disabled="disabled" clearable filterable remote reserve-keyword
					multiple collapse-tags :remote-method="remoteMethod" :loading="loading" style="margin-left: 10px;"
					:placeholder="placeholder" ref="selectautocomplete" class="elselect" :style="fromelect">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'selectautocompletetow'">
			<div style="display: inline-block" v-if="jxs">
				<label :style="[
            { fontSize: `${fontSize}` },
            { color: `${color}` },
            { width: `${lablewith}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<el-select v-model="modelvalue" clearable filterable remote reserve-keyword
					:remote-method="remoteMethodtow" :loading="loading" style="margin-left: 10px;"
					:placeholder="placeholder" ref="selectautocompletetow" class="elselect" :style="fromelect">
					<el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
			</div>
		</template>
		<template v-if="inputtype == 'radio'">
			<div style="width: 310px;" v-if="selcoms">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<el-radio v-model="radios" label="1" :disabled="disabled" style="position: relative;right: 30px;">
					{{ radiotitle1 }}
				</el-radio>
				<el-radio v-model="radios" label="0" :disabled="disabled" style="position: relative;">{{
          radiotitle2
        }}</el-radio>
			</div>
		</template>
		<template v-if="inputtype == 'checkbox'">
			<div style="display: flex;justify-content: space-around;align-items: center; ">
				<div v-if="laboo">
					<label :style="[
              { width: `${lablewith}` },
              { fontSize: `${fontSize}` },
              { color: `${color}` },
            ]">
						<slot></slot>
						{{ title }}:
					</label>
				</div>

				<div :style="[
            { position: `${position}` },
            { top: `${top}` },
            { fontSize: `${fontSize}` },
          ]" style="  width: 450px;position: relative; display: flex;justify-content: space-between;flex-wrap: wrap">
					<el-checkbox-group v-model="boxsdata" @change="handleCheckedCitiesChange"
						style="margin-left: 15px; margin-top: 20px;">
						<el-checkbox v-for="(item, index) of checkboxdata" :label="item.AUID" :key="index"
							:style="{ width: `${lablewidthbox}` }"
							style="margin-left: 10px; margin-top: 20px; text-align: left; position: relative; bottom: 10px;">
							{{ item.AuthorityName }}({{ item.AuthorityCode }})
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'checkboxes'">
			<div style="display: flex;justify-content: space-around;align-items: center; ">
				<div v-if="laboo">
					<label :style="[
              { width: `${lablewith}` },
              { fontSize: `${fontSize}` },
              { color: `${color}` },
            ]">
						<slot></slot>
						{{ title }}:
					</label>
				</div>

				<div :style="[
            { position: `${position}` },
            { top: `${top}` },
            { fontSize: `${fontSize}` },
          ]" style="  width: 450px;position: relative; display: flex;justify-content: space-between;flex-wrap: wrap">
					<el-checkbox-group v-model="boxsdata" @change="handleCheckedCitiesChange"
						style="margin-left: 15px;">
						<el-checkbox v-for="(item, index) of checkboxdata" :label="item.label" :key="index"
							:style="{ width: `${lablewidthbox}` }"
							style="text-align: left; position: relative; bottom: 0px;">
							{{ item.value }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'checkboxets'">
			<div style="display:flex;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]" style="display:inline-block;">
					<slot></slot>
					{{ title }}:
				</label>

				<el-checkbox-group v-model="boxsdata" @change="handleCheckedCitiesChangets"
					style="margin-left: 15px;display:flex;">
					<el-checkbox v-for="(item, index) of checkboxdata" :label="item.label" :key="index"
						:style="{ width: `${lablewidthbox}` }"
						style="text-align: left; position: relative; bottom: 0px;">
						{{ item.value }}
					</el-checkbox>
				</el-checkbox-group>
			</div>
		</template>
		<template v-if="inputtype == 'checkboxs'">
			<div style="display: flex;justify-content: space-around;align-items: center; " v-if="checkFlag">
				<div v-if="laboo">
					<label :style="[
              { width: `${lablewith}` },
              { fontSize: `${fontSize}` },
              { color: `${color}` },
            ]">
						<slot></slot>
						{{ title }}:
					</label>
				</div>

				<div :style="[{ fontSize: `${fontSize}`, width: `${width}` }]" style=" ">
					<!-- <el-checkbox-group v-model="boxsdata" @change="handleCheckedCitiesChange"> -->
					<el-checkbox true-label="1" false-label="0" v-model="modelvalue"
						v-for="(item, index) of checkboxdata" @change="handleCheckedCitiesChange" :label="item.label"
						:key="index" :style="{ width: `${lablewidthbox}` }"
						style="margin-left: 10px; margin-top: 20px; text-align: left; position: relative; bottom: 10px;">
						{{ item.value }}
					</el-checkbox>
					<!-- </el-checkbox-group> -->
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'date'">
			<div style="" class="date" :style="{ marginLeft: `${marginLeft}` }">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<!-- :picker-options="pickerOptionscreate" -->
					<el-date-picker v-model="startTime" type="date" value-format="yyyy-MM-dd" ref="date"
						placeholder="选择日期" @change="change1" style="width: 140px;">
					</el-date-picker>
					<span style="color: #999999;font-size: 14px;display: inline-block;margin-left: 13px;">-</span>
					<!-- :picker-options="pickerOptionsend" -->
					<el-date-picker v-model="endTime" type="date" value-format="yyyy-MM-dd" ref="dates"
						placeholder="选择日期" @change="change2">
					</el-date-picker>
				</div>
			</div>
		</template>

		<template v-if="inputtype == 'datey'">
			<div style="" class="dates">
				<label :style="[
		    { width: `${lablewith}` },
		    { fontSize: `${fontSize}` },
		    { color: `${color}` },
		  ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;">
						<!-- :picker-options="pickerOptionscreate" -->
						<el-date-picker v-model="modelvalue" :clearable="false" :style="dates" type="year"
							value-format="yyyy" ref="date" placeholder="选择日期" @change="change3"
							style="width: 100%!important;" :disabled="disabled">
						</el-date-picker>
					</div>
				</div>
			</div>
		</template>

		<template v-if="inputtype == 'dates'">
			<div style="" class="dates">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;" class="datess">
						<!-- :picker-options="pickerOptionscreate"  :style="dates"-->
						<el-date-picker :style="{ width: `${width}` }" v-model="modelvalue" type="date"
							value-format="yyyy-MM-dd" ref="date" placeholder="选择日期" @change="change3"
							:disabled="disabled">
						</el-date-picker>
					</div>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'datemonth'">
			<div style="" class="dates">
				<label :style="[
		    { width: `${lablewith}` },
		    { fontSize: `${fontSize}` },
		    { color: `${color}` },
		  ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;" class="datess">
						<!-- :picker-options="pickerOptionscreate" -->
						<el-date-picker v-model="modelvalue" :style="dates" type="month" value-format="yyyy-MM"
							ref="date" placeholder="选择日期" @change="change3" style="width: 200px;" :disabled="disabled">
						</el-date-picker>
					</div>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'datess'">
			<div style="" class="dates" v-if="dateFlag">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;" class="datess">
						<!-- :picker-options="pickerOptionscreate" -->
						<el-date-picker v-model="modelvalue" type="date" value-format="yyyy-MM-dd" ref="date"
							placeholder="选择日期" @change="change3" style="width: 190px;">
						</el-date-picker>
					</div>
				</div>
			</div>
		</template>
		   
		<!-- 日期选择框(区间) -->
		    <template v-if="inputtype == `dateSection`">
			  <div style="" class="">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				          <span style="color: #E71D43;  position: relative;top: 2px;" v-if="btx">*</span>
				        <el-date-picker :style="[ { width: `${ widthLeft }px` }, { height: `${ heightLeft }px` }  ]"
					v-model="endTime" value-format="yyyy-MM-dd" :placeholder="placeholder" @input="datetimeChange"
					:disabled="disabled">
					        </el-date-picker>
				        <div style="display:inline-block;margin-left: 10px;margin-right: 10px;">-</div>
				        <el-date-picker :style="[ { width: `${ widthRight }px` }, { height: `${heightRight }px` }  ]"
					v-model="startTime" value-format="yyyy-MM-dd" :placeholder="placeholder" @input="datetimeChange"
					:disabled="disabled">
					        </el-date-picker>
				     
			</div>
			    </template>

		<template v-if="inputtype == 'dateda'">
			<div style="" class="dateda">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;" class="dateone">
						<!-- :picker-options="pickerOptionscreate" -->
						<el-date-picker v-model="endTime" type="date" value-format="yyyy-MM-dd" ref="date"
							placeholder="选择日期" @change="change1" style="width: 200px;">
						</el-date-picker>
					</div>

					<span style="color: #999999;font-size: 14px;display: inline-block;margin-left: -5px;">-</span>

					<div style="display: inline-block;" class="datetow">
						<!-- :picker-options="pickerOptionsend" -->
						<el-date-picker v-model="startTime" type="date" value-format="yyyy-MM-dd" ref="dates"
							placeholder="选择日期" @change="change2">
						</el-date-picker>
					</div>
				</div>
				<!-- 
        <el-date-picker type="date" :placeholder="placeholder" v-model="inputdata" :style="fromelect" style="height: 32px"></el-date-picker>
        
        <el-date-picker type="date" :placeholder="placeholder" v-model="inputdata" :style="fromelect" style="width: 140px;"></el-date-picker> -->
			</div>
		</template>
		<template v-if="inputtype == 'datedas'">
			<div style="" class="datedas">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div style="display:inline-block; margin-left: -2px;">
					<div style="display: inline-block;" class="dateone">
						<!-- :picker-options="pickerOptionscreate" -->
						<el-date-picker v-model="endTime" type="date" value-format="yyyy-MM-dd" ref="date"
							placeholder="选择日期" @change="change1" style="width: 200px;">
						</el-date-picker>
					</div>

					<span style="color: #999999;font-size: 14px;display: inline-block;margin-left: -5px;">-</span>

					<div style="display: inline-block;" class="datetow">
						<!-- :picker-options="pickerOptionsend" -->
						<el-date-picker v-model="startTime" type="date" value-format="yyyy-MM-dd" ref="dates"
							placeholder="选择日期" @change="change2">
						</el-date-picker>
					</div>
				</div>
				<!-- 
        <el-date-picker type="date" :placeholder="placeholder" v-model="inputdata" :style="fromelect" style="height: 32px"></el-date-picker>
        
        <el-date-picker type="date" :placeholder="placeholder" v-model="inputdata" :style="fromelect" style="width: 140px;"></el-date-picker> -->
			</div>
		</template>
		<template v-if="inputtype == 'number'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<el-input-number :style="{ width: `${width}` }" :disabled="disabled" style="margin-left: 10px;"
					v-model="modelvalue" controls-position="right" @change="handleChanges" :min="min" :max="max"
					size="small">
				</el-input-number>
			</div>
		</template>
		<template v-if="inputtype == 'numbers'">
			<div style="width: 100%;" class="numbers">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalueleft" placeholder="请输入"
					:controls="showControls" controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
				</el-input-number>
				<span
					style="color: #999999;font-size: 14px;display: inline-block;margin-left: 0px;padding-left: 7px;padding-right: 7px;">-</span>
				<el-input-number :style="{ width: `${width}` }" style="" v-model="modelvalueright" placeholder="请输入"
					:controls="showControls" controls-position="right" @change="handleChanges" :min="minrigth" :max="maxrigth" size="small">
				</el-input-number>
			</div>
		</template>
		<template v-if="inputtype == 'numberpro'">
			<div style="width: 100%;" class="numberpro">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalueleft"
					controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
				</el-input-number>
				<span
					style="color: #999999;font-size: 14px;display: inline-block;margin-left: 0px;padding-left: 7px;padding-right: 7px;">-</span>
				<el-input-number :style="{ width: `${width}` }" style="" v-model="modelvalueright"
					controls-position="right" @change="handleChanges" :min="minrigth" :max="maxrigth" size="small">
				</el-input-number>
			</div>
		</template>
		<template v-if="inputtype == 'numbertow'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
					controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
				</el-input-number>
				<span style="color: #999999;font-size: 14px;display: inline-block;margin-left: 6px;">-</span>
				<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
					controls-position="right" @change="handleChanges" :min="minrigth" :max="maxrigth" size="small">
				</el-input-number>
			</div>
		</template>
		<template v-if="inputtype == 'numbertows'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numbertows">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
						controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<el-tooltip effect="dark" :disabled="!content" placement="top-end">
			<div slot="content" v-html="content"></div>
			<template v-if="inputtype == 'numbertowCQ'">
				<div style="width: 100%;">
					<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
						<slot></slot>
						{{ title }}:
					</label>
					<div class="numbertowCQ">
						<el-input-number :style="{ width: `${width}` }" :disabled="disabled" style="margin-left: 10px;"
							v-model="modelvalue" controls-position="right" @change="handleChanges" :min="minleft"
							:max="maxleft" size="small">
						</el-input-number>
					</div>
				</div>
			</template>
		</el-tooltip>
		<template v-if="inputtype == 'numbertowOI'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numbertowOI">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
						controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'numberAL'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numberAL">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
						controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'numberINV'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numberINV">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
						controls-position="right" @change="handleChanges" :min="minleft" :max="maxleft" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'numberPX'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numberPX" :style="numberPX">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="modelvalue"
						controls-position="right" @change="handleChanges" :min="min" :max="max" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'numberComm'">
			<div style="width: 100%;">
				<label :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>
				<div class="numberPX" :style="numberPX">
					<el-input-number :style="{ width: `${width}` }" style="margin-left: 10px;" v-model="CommModelvalue"
						controls-position="right" @change="handleChanges" :min="min" :max="max" size="small">
					</el-input-number>
				</div>
			</div>
		</template>
		<template v-if="inputtype == 'textarea'">
			<div style="width: 100%;">
				<label style="position: absolute;" :style="[
            { width: `${lablewith}` },
            { fontSize: `${fontSize}` },
            { color: `${color}` },
          ]">
					<slot></slot>
					{{ title }}:
				</label>

				<!-- <el-input style="margin-left: 90px;" type="textarea" :autosize="{ minRows: min, maxRows: max}" placeholder="请输入内容" v-model="inputdata" :style="fromelect" :style="[{ width: `${ width }`}]">

        </el-input> -->
				<textarea style="margin-left: 90px;border: 1px solid #E6E6E6;border-radius: 2px;height: 400px;"
					type="textarea" placeholder="请输入内容" v-model="modelvalue" :style="[{ width: `${width}` }]" />
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			// 字体颜色
			color: {
				type: String,
				default: "#333333",
			},
			// 文本框/下拉框宽度
			width: {
				type: String,
				default: "220px",
			},
			widths: {
				type: String,
				default: "140px",
			},
			// 有标题框宽度
			lablewith: {
				type: String,
				default: "80px",
			},
			// 复选框宽度
			lablewidthbox: {
				type: String,
				default: "",
			},
			// 文本框高度
			height: {
				type: String,
				default: "32px",
			},
			// 标题
			title: {
				type: String,
				default: "",
			},
			// 单选框标题1
			radiotitle1: {
				type: String,
				default: "",
			},
			// 单选框标题2
			radiotitle2: {
				type: String,
				default: "",
			},
			// 字体大小
			fontSize: {
				type: String,
				default: "16px",
			},
			// 文本框边框弧度
			borderRadius: {
				type: String,
				default: "2px",
			},
			// 文本框placeholder
			placeholder: {
				type: String,
				default: "请选择",
			},
			// 下拉框
			select: {
				type: String,
				default: "",
			},
			// 文本input框
			input: {
				type: String,
				default: "",
			},
			// 单选框
			radio: {
				type: [String, Number, Boolean],
				default: "",
			},
			// 日期控件
			date: {
				type: String,
			},
			// input类型
			inputtype: {
				type: String,
				default: "",
			},
			// 下拉框值
			options: {
				type: [Array, Object],
			},
			// 获取输入的值
			inputdata: {
				type: [String, Number, Array, Boolean],
				default: "",
			},
			// input的类型
			types: {
				type: String,
				default: "text",
			},
			// 多选框的标题
			checkboxlable: {
				type: String,
				default: "text",
			},
			// 渲染多选框的数据
			checkboxdata: {
				type: Array,
				default: Array,
			},
			// 多选框的高度
			widthbox: {
				type: String,
				default: "450px",
			},

			// 多选框定位
			position: {
				type: String,
				default: "relative",
			},
			// 定位上面的距离
			top: {
				type: String,
				default: "10px",
			},
			// 加减框的最小值
			min: {
				type: Number,
				default: 1,
			},
			// 加减框的最大值
			max: {
				type: Number,
				// default: 5000
			},
			minrigth: {
				type: Number,
				default: undefined,
			},
			// 加减框的最大值
			minleft: {
				type: Number,
				default: undefined,
			},
			maxleft: {
				type: Number,
				default: undefined
			},
			maxrigth: {
				type: Number,
				// default: 5000
			},
			// 多选框是否有标题
			laboo: {
				type: Boolean,
				default: true,
			},
			// 左边距
			marginLeft: {
				type: String,
				default: "5px",
			},
			// 是否必填项
			btx: {
				type: Boolean,
				default: false,
			},
			// 是否可填
			disabled: {
				type: Boolean,
				default: false,
			},
			boxsdata: {
				type: Array,
				default: function() {
					return [];
				},
			},
			boxsdatats: {
				type: Array,
				default: function() {
					return [];
				},
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			cityname: {
				type: String,
				default: "province",
			},
			autocomplete: {
				type: String,
				default: "off",
			},
			icon: {
				type: Boolean,
				default: false,
			},
			event: {
				type: String,
				default: "",
			},
			pt: {
				type: Boolean,
				default: false,
			},
			jxs: {
				type: Boolean,
				default: false,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			selcoms: {
				type: Boolean,
				default: true,
			},
			inputflag: {
				type: Boolean,
				default: true,
			},
			disabledHB: {
				type: Boolean,
				default: true,
			},
			widthLeft: {
				type: Number,
			},
			widthRight: {
				type: Number,
			},
			heightLeft: {
				type: Number,
				default: 32,
			},
			heightRight: {
				type: Number,
				default: 32,
			},
			content: {
				type: String,
				default: "",
			},
			dateFlag: {
				type: Boolean,
				default: true,
			},
			checkFlag: {
				type: Boolean,
				default: true,
			},
			showControls: {
				type: Boolean,
				default: true,
			}
		},
		data: function() {
			return {
				modelvalue: this.inputdata,
				optionsValue: this.options,
				radios: this.radio,
				endTime: "",
				startTime: "",
				refsele: undefined,
				selectautocomplete: undefined,
				selectautocompletes: undefined,
				selectautocompletetow: undefined,
				modelvalueleft: undefined,
				modelvalueright: undefined,
				CommModelvalue: undefined,
				boxdata: [],
				normalizer(node) {
					return {
						id: node.NodeID,
						label: node.NodeName,
						children: node.Nodes,
					};
				},
			};
		},
		created() {
			this.selectautocomplete = this.$refs;
			this.selectautocompletes = this.$refs.selectautocompletes;
			this.selectautocompletetow = this.$refs.selectautocompletetow;
			this.refsele = this.$refs.elselect;
		},
		mounted() {},
		computed: {
			fromelect() {
				return {
					"--el-select-height": this.height,
					"--el-select-width": this.width,
					"--el-select-borderRadius": this.borderRadius,
				};
			},
			numberPX() {
				return {
					"--el-numberPX-width": this.widths,
				};
			},
			dates() {
				return {
					"--el-date-width": this.widths,
				};
			},
		},
		methods: {
			// 日期框选择刷新选择框的值
			datetimeChange(e) {
				let _this = this
				_this.$forceUpdate();
			},
			handleChange() {
				this.$emit(handleChange, "handleChange");
			},
			handleChanges(value) {},
			change2(value) {
				this.$emit("change2", value);
			},
			change1(value) {
				this.$emit("change1", value);
			},
			change3(value) {
				this.$emit("change3", value);
			},
			cascaderchange(e) {
				this.$emit("cascaderchange", e);
			},
			handleCheckedCitiesChange(val) {
				this.$emit("handleCheckedCitiesChange", val);
			},
			handleCheckedCitiesChangets(val) {
				this.$emit("handleCheckedCitiesChangets", val);
			},
			city(value) {
				this.$emit("city", value);
			},
			province(value) {
				this.$emit("province", value);
			},
			inputChange(e) {},
			iconclick() {
				this.$emit("iconclick");
			},
			querySearchAsync(queryString, callback) {
				let par = {
					queryString,
					callback,
				};
				this.$emit("querySearchAsync", par);
			},
			querySearchAsynctow(queryString, callback) {
				let par = {
					queryString,
					callback,
				};
				this.$emit("querySearchAsynctow", par);
			},
			handleSelect(item) {
				this.$emit("handleSelect", item);
			},
			handleSelecttow(item) {
				this.$emit("handleSelecttow", item);
			},
			remoteMethod(query) {
				this.$emit("remoteMethod", query);
			},
			remoteMethodtow(query) {
				this.$emit("remoteMethodtow", query);
			},
			remoteMethodtows(query) {
				this.$emit("remoteMethodtows", query);
			},
			remoteMethodtowHB(query) {
				this.$emit("remoteMethodtowHB", query);
			},
			remoteMethodtowHP(query) {
				this.$emit("remoteMethodtowHP", query);
			},
			remoteMethodtowPer(query) {
				this.$emit("remoteMethodtowPer", query);
			},
			remoteHosType(query) {
				this.$emit("remoteHosType", query);
			},
			events(e) {
				try {
					if (this.event && this.$options.methods[this.event]) {
						this.$options.methods[this.event].call(this, e);
					}
				} catch (e) {
					// //console.log("异常",e)
				}
			},
			gsChage(e) {
				this.$emit("gsChage", this);
			},
			gsChageupdate(e) {
				this.$emit("gsChageupdate", this);
			},
			jxsType(e) {
				this.$emit("jxsType", this);
			},
			updatedealer(e) {
				this.$emit("updatedealer", this);
			},
			SalesType(e) {
				this.$emit("SalesType", this);
			},
			hospitalChange(e) {
				this.$emit("hospitalChange", this);
			},
			provinceChage(e) {
				this.$emit("provinceChage", this);
			},
			invClass(e) {
				this.$emit("invClass", this);
			},
			LEVEL2(e) {
				this.$emit("LEVEL2", this);
			},
			BaChage(e) {
				this.$emit("BaChage", this);
			},
			BanewChage(e) {
				this.$emit("BanewChage", this);
			},
			TBnewChage(e) {
				this.$emit("TBnewChage", this);
			},
			TBChage(e) {
				this.$emit("TBChage", this);
			},
			TBChageUp(e) {
				this.$emit("TBChageUp", this);
			},
			TBnewChageUp(e) {
				this.$emit("TBnewChageUp", this);
			},
			wCodeChage(e) {
				this.$emit("wCodeChage", e);
			},
			U8AccId(e) {
				this.$emit("U8AccId", this);
			},
			HosTypeChage(e) {
				this.$emit("HosTypeChage", this);
			},
			HosTypeJsChage(e) {
				this.$emit("HosTypeJsChage", this);
			},
			JXSChage(e) {
				this.$emit("JXSChage", this);
			},
			JXSUPChage(e) {
				this.$emit("JXSUPChage", this);
			},
			invClassChage(e) {
				this.$emit("invClassChage", this);
			},
			CusTypeChage(e) {
				this.$emit("CusTypeChage", this);
			},
			level1Chage(e) {
				this.$emit("level1Chage", this);
			},
			level2Chage(e) {
				this.$emit("level2Chage", this);
			},
			level3Chage(e) {
				this.$emit("level3Chage", this);
			},
			voucherTypeChange(e) {
				this.$emit("voucherTypeChange", this);
			},
			terminalHospitalChange(e) {
				this.$emit("terminalHospitalChange", this);
			},
		},
		watch: {
			options(newVal) {
				this.optionsValue = newVal;
			},
			inputdata(newdata) {
				this.modelvalue = newdata;
			},
			modelvalue(val) {
				this.$emit("change", val);
			},
			radio(newval) {
				this.radios = newval;
			},
			radios(val) {
				this.$emit("changes", val);
			},
		},
	};
</script>
<style lang="less">
	// @import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	/deep/.el-input-number.is-without-controls .el-input__inner {
		width: 500px;
		line-height: 30px;
		height: 28px;
	}

	input:focus {
		border-color: #e71d43;
	}

	.el-cascader-panel .el-radio {
		width: 100%;
		height: 100%;
		z-index: 10;
		position: absolute;
		top: 10px;
		right: 10px;
	}

	.el-cascader-panel .el-radio__input {
		visibility: hidden;
	}

	.el-cascader-panel .el-cascader-node__postfix {
		top: 10px;
	}

	.el-cascader-menu {
		height: 100%;
		width: 230px;
	}
</style>

<style lang="less" scoped>
	input {
		padding-left: 8px;
	}

	.cascaderstyle {
		/deep/.el-input--suffix .el-input__inner {
			width: var(--el-select-width);
			// height: 32px !important;
			border-radius: var(--el-select-borderRadius);
			overflow: scroll;
		}
	}

	.date {
		/deep/.el-input--suffix .el-input__inner:nth-child(1) {
			padding-right: 25px;
			height: 32px;
			width: 140px;
			border-radius: 2px;
		}
	}

	.dates {
		/deep/.el-input--suffix .el-input__inner:nth-child(1) {
			padding-right: 30px;
			height: 32px;
			width: 220px;
			border-radius: 2px;
		}
	}

	.dateda {
		.datetow {
			/deep/.el-input--suffix .el-input__inner {
				height: 32px;
				width: 255px;
				border-radius: 2px;
			}
		}

		.dateone {
			/deep/.el-input--suffix .el-input__inner {
				height: 32px;
				width: 180px;
				border-radius: 2px;
			}
		}
	}

	.datedas {
		.datetow {
			/deep/.el-input--suffix .el-input__inner {
				height: 32px;
				width: 283px;
				border-radius: 2px;
			}
		}

		.dateone {
			/deep/.el-input--suffix .el-input__inner {
				height: 32px;
				width: 190px;
				border-radius: 2px;
			}
		}
	}

	.datess {
		/deep/.el-input--suffix .el-input__inner:nth-child(1) {
			padding-right: 30px;
			height: 32px;
			width: var(--el-date-width);
			border-radius: 2px;
		}
	}

	.elselect {
		/deep/.el-input--suffix .el-input__inner {
			padding-right: 30px;
			height: var(--el-select-height) !important;
			width: var(--el-select-width);
			border-radius: var(--el-select-borderRadius);
		}

		/deep/.el-select__tags-text {
			max-width: 80px;
		}
	}

	/deep/.el-input__icon {
		line-height: var(--el-select-height);
	}

	label {
		display: inline-block;
		width: 80px;
		text-align: right;
	}

	/deep/.el-input__inner {
		// height: var(--el-select-height);
		// width: var(--el-select-width);
		// border-radius: var(--el-select-borderRadius);
	}

	// 添加颜色类
	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #e71d43 !important;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		background: #e71d43 !important;
		border-color: #e71d43 !important;
	}

	/deep/.el-checkbox {
		width: 95px;
		text-align: left;
	}

	/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #e71d43;
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #e71d43;
	}

	/deep/.el-checkbox.is-bordered.is-checked {
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #e71d43;
	}

	/deep/.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 140px;
		margin-left: 11px;
	}

	// /deep/.el-input-number.is-controls-right .el-input__inner {
	//   padding-left: 15px;
	//   padding-right: 50px;
	//   border-radius: 2px;
	//   height: 32px;
	// }
	/deep/.el-input-number.is-controls-right .el-input__inner {
		padding-left: 15px;
		padding-right: 21px;
		border-radius: 2px;
		height: 32px;
	}

	/deep/.el-input-number.is-controls-right .el-input__inner {
		width: 74px;
		padding-left: 0px;
	}

	.numberpro {
		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 95px;
			padding-left: 0px;
		}
	}

	.range-wrapper {
		display: inline-block;

		label {
			color: #606060;
		}
	}

	/deep/.el-cascader .el-input .el-input__inner:focus,
	.el-cascader .el-input.is-focus .el-input__inner {
		border-color: #dfd7d7;
	}

	.numbertows {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 221px;
			padding-left: 0px;
		}
	}

	.numbertowCQ {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 190px;
			padding-left: 0px;
		}
	}

	.numbertowOI {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 211px;
			padding-left: 0px;
		}
	}

	.numberAL {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 491px;
			padding-left: 0px;
		}
	}

	.numberINV {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: 410px;
			padding-left: 0px;
		}
	}

	.numberPX {
		display: inline-block;

		/deep/.el-input-number.is-controls-right .el-input__inner {
			width: var(--el-numberPX-width);
			padding-left: 0px;
		}
	}

	input {
		border: 1px solid #e6e6e6;
	}

	input:focus {
		transition: all .8s;
		border: 1px solid #e71d43;
	}

	/deep/.el-input__inner:focus {
		transition: all .8s;
		border: 1px solid #e71d43;
	}

	/deep/.el-select .el-input.is-focus .el-input__inner {
		transition: all .8s;
		border-color: #e71d43;
	}

	/deep/.el-select .el-input__inner:focus {
		transition: all .8s;
		border-color: #e71d43;
	}

	/deep/.el-input__inner {
		border: 1px solid #e6e8eb;
		// background-color: #fafbfc;
		font-size: 14px;
		color: #16181a;
		border-radius: 2px;
		height: 32px;
		padding-left: 10px;
		// margin-top: 6px;
	}

	/deep/input:disabled {
		border: none;
		background-color: transparent;
	}

	/deep/.el-cascader__tags {
		top: 60%;
	}
</style>
